import {action, makeAutoObservable} from "mobx"
import PriceSettingsApi from "../../api/PriceSettingsApi"
import {CommandData} from "../../utils/RequestsHelper";
import Warehouse from "../entities/Warehouse"
import {SelectProductsState} from "../../components/SelectProductsCategoriesOrSets"
import StockSettingsApi from "../../api/StockSettingsApi"
import Rule from "../entities/rules/Rule"


class PriceSettingsController {
    public productSyncByOptions = [
        {label: "ID артикула", value: "sku_id"},
        {label: "ID товара", value: "product_id"},
        {label: "Код артикула", value: "sku_code"}
    ]

    public historyOptions = [
        {label: "1 день", value: '1'},
        {label: "3 дня", value: '3'},
        {label: "5 дней", value: '5'},
        {label: "7 дней", value: '7'},
        {label: "10 дней", value: '10'},
        {label: "20 дней", value: '20'},
        {label: "30 дней", value: '30'},
    ]

    constructor() {
        makeAutoObservable(this)
    }

    // get warehousesOptions() {
    //     const options = [
    //         {label: "Все", value: "all"},
    //     ]
    //     if (this._shop_warehouses.length > 0) {
    //         options.push({label: "Выбранные", value: "selected"})
    //     }
    //     return options
    // }
    //
    // private _ozon_warehouses: Warehouse[] | undefined
    //
    // get ozon_warehouses(): Warehouse[] | undefined {
    //     return this._ozon_warehouses
    // }

    private _syncStock: CommandData | undefined

    /**
     * @deprecated The method should not be used since 1.4.21
     */
    get syncStock(): CommandData | undefined {
        return this._syncStock
    }

    private _syncProducts: CommandData | undefined

    get syncProducts(): CommandData | undefined {
        return this._syncProducts
    }

    get valueOfProductFindBy(): { label: string; value: string } {
        let option
        if (this.productSyncBy === "sku_code") {
            option = this.productSyncByOptions[2]
        } else if (this.productSyncBy === "product_id") {
            option = this.productSyncByOptions[1]
        } else {
            option = this.productSyncByOptions[0]
        }
        return option
    }

    private _productCollectionSettings: SelectProductsState = {
        selectType: 'fromExport',
        productCollectionType: 'categories',
        selectedCategories: [],
        selectedSets: [],
    }

    get productCollectionSettings(): SelectProductsState {
        return this._productCollectionSettings;
    }

    set productCollectionSettings(value: SelectProductsState) {
        this._productCollectionSettings = value;
        this.saveProductCollectionSettings();
    }

    // private _shop_warehouses: shopWarehouse[] = []
    //
    // get shop_warehouses(): shopWarehouse[] {
    //     return this._shop_warehouses
    // }

    private _productSyncBy: string = "sku_id"

    get productSyncBy(): string {
        return this._productSyncBy
    }

    set productSyncBy(value: string) {
        this._productSyncBy = value
        PriceSettingsApi.setProductSyncBy(value)
    }

    private _historyDaysKeep: number = 3

    get historyDaysKeep(): number {
        return this._historyDaysKeep
    }

    prices: Rule[] = []

    set historyDaysKeep(value: number) {
        this._historyDaysKeep = value
        PriceSettingsApi.setHistoryDaysKeep(value)
    }

    loadSettings() {
        return PriceSettingsApi.getSettings().then(
            action("settingsFetched", (response) => {
                const priceSettings = response.data.data
                this._productSyncBy = priceSettings.productSyncBy
                this._historyDaysKeep = priceSettings.historyDaysKeep
                this._productCollectionSettings = priceSettings.productCollectionSettings
                const rules = [];
                for (const rule of priceSettings.prices) {
                    rules.push(new Rule(rule))
                }
                this.prices = rules
            })
        )
    }

    private saveProductCollectionSettings() {
        PriceSettingsApi.setProductCollectionSettings(this.productCollectionSettings)
    }
}

const priceSettingsController = new PriceSettingsController()
export default priceSettingsController